var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/System/Edit"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0208,2.4142 L13.4348,1.0002 L16.9708,4.5352 L15.5568,5.9502 L12.0208,2.4142 Z M5.1848,16.3212 L1.0608,16.9102 L1.6498,12.7852 L11.3138,3.1212 L14.8488,6.6572 L5.1848,16.3212 Z M17.6778,3.8282 L14.1418,0.2932 C13.7518,-0.0978 13.1188,-0.0978 12.7278,0.2932 L11.4668,1.5542 L10.8108,2.2102 L0.7068,12.3132 L-0.000199999999,17.2632 L0.7068,17.9702 L5.6568,17.2632 L17.6778,5.2422 C18.0678,4.8522 18.0678,4.2192 17.6778,3.8282 L17.6778,3.8282 Z",
    id: "Fill-1",
    fill: "#242c33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.0ad48f1c6aee6bc1ea19176e325a296f.svg";
export { ForwardRef as ReactComponent };